<div class="post-user-options--wrapper" (click)="toggleMenu()">
  <ark-icon
    icon="system-more-vertical"
    size="medium"
    color="inactive"
  ></ark-icon>
  <div
    class="options-menu"
    [@tabAnimation]=""
    *ngIf="menuActive"
    (mouseleave)="menuActive = false"
  >
    <ng-content></ng-content>
  </div>
</div>
